// Legacy PaymentService entry point — kept ONLY for backwards compatibility.
import angular from 'angular';

// Re-export so existing imports keep working.
export { PaymentService } from '@ng/core/payment/payment.service';
export type { PaymentServiceEvents, PaymentState } from '@ng/core/payment/payment.service.types';

/**
 * Empty AngularJS module — preserved so `acme.common.service.payment`
 * keeps resolving. The actual factory is registered in ng-downgraded-components.ts.
 */
export const PaymentServiceModule = angular.module('acme.common.service.payment', []).name;
